module.exports = __webpack_public_path__ + "img/HOME-3.2ceec5d9.png";